import { render, staticRenderFns } from "./CategoryNavbar.vue?vue&type=template&id=6df8dbce&scoped=true&"
import script from "./CategoryNavbar.vue?vue&type=script&lang=ts&"
export * from "./CategoryNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryNavbar.vue?vue&type=style&index=0&id=6df8dbce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df8dbce",
  null
  
)

export default component.exports